import React, {useEffect, useState} from 'react';
import 'swiper/swiper.min.css';
import {MobileFooterContainer, SubTabTableArea,} from "communitypage/blog/BlogPage";
import {LanguageService} from "language/LanguageService";
import clsx from "clsx";
import {RouteComponentProps, useLocation, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {ACTION_TYPES} from "store/ActionTypes";
import {SsqImages} from "images/SsqImages";
import {AccountService} from "repositories/AccountService";
import {LANG_KO_KR, langutil} from "language/langutil";
import {useIsLogin} from "hooks/useIsLogin";


interface Props extends RouteComponentProps<any> {

  languageService: LanguageService;
  getTranslation: Function;
  loginInfo: IfLoginInfo;
  accountService: AccountService;

  displayLoginPopup: Function;
}


const MobileFooter = (props: Props) => {

  const [activeIndex, setActiveIndex] = useState('');

  const [blog, setBlog] = useState(false);
  const [board, setBoard] = useState(false);
  const [qna, setQna] = useState(false);
  const [write, setWrite] = useState(false);
  const [sample, setSample] = useState(false);
  //const [isLogin, setIsLogin] = useState(false);

  const isLogin = useIsLogin();

  const pathName = useLocation().pathname;

  const {country, lang} = langutil.splitLangCode(props.languageService.lang());

  //props.accountService.isLoggedIn().then((response) => setIsLogin(response));

  const tabClickHandler = (index) => {
    setActiveIndex(index);

    switch (index) {
      case "qna" :
        setQna(!qna);
        if (!qna) {
          window.history.replaceState("", "/community/qna", `/${country}/${lang}/community/qna`);
          location.reload();
          return setQna(qna);
        }
        return setQna(qna);

      case "blog":
        setBlog(!blog);
        if (!blog) {
          window.history.replaceState("", "/community/blog", `/${country}/${lang}/community/blog`);
          location.reload();
          return setBlog(blog);
        }
        return setBlog(blog);

      case "board":
        setBoard(!board);
        if (!board) {
          window.history.replaceState("", "/community/board", `/${country}/${lang}/community/board`);
          location.reload();
          return setBoard(board);
        }
        return setBoard(board);

      case "sample" :
        setSample(!sample);
        if (!sample) {
          window.history.replaceState("", "/service/sample", `/${country}/${lang}/service/sample`);
          location.reload();
          return setSample(sample);
        }
        return setSample(sample);

      case "write":
        setWrite(!write);
        /*  if (!write) {
              window.history.replaceState("", "/community/new/0", `/community/new/0`);
            location.reload();
            return setBoard(write);
          }*/
        if (!isLogin) {
          props.displayLoginPopup();
          return setWrite(write);
        } else {
          switch (pathName) {
            case `/${country}/${lang}/community/qna`:
              window.open(`/${country}/${lang}/community/new/0?docgrp=qna`);
              break;
            case `/${country}/${lang}/community/blog`:
              window.open(`/${country}/${lang}/community/new/0?docgrp=blog`);
              break;
            case `/${country}/${lang}/community/board`:
              window.open(`/${country}/${lang}/community/new/0?docgrp=info`);
              break;
            case `/${country}/${lang}/service/sample` :
              window.open(`/${country}/${lang}/community/new/0?docgrp=sample`);
          }
          return setWrite(write);
        }

      default:
        return 'ex';
    }
  };


  const tabContArr = [

    {
      tabTitle: (
        props.languageService.getLanguage() === LANG_KO_KR ? <li key={0}>
          <button className={clsx("c-footer qna", activeIndex == 'qna' ? 'on' : pathName == `/${country}/${lang}/community/qna` ? 'on' : '')}
            onClick={() => tabClickHandler('qna')}>
            <span className="icon">
               <img alt={"sample.svg"} src={SsqImages.community.communityFooterQna()} className="icon"/>
            </span>
            <span className="name">{props.getTranslation("I18N_TITLE_COMMUNITY_QNA")}</span>
          </button>
        </li> : null

      ),
    },

    {
      tabTitle: (
        <li key={1}>
          <button className={clsx("c-footer blog", activeIndex == 'blog' ? 'on' : pathName == `/${country}/${lang}/community/blog` ? 'on' : '')}
            onClick={() => tabClickHandler('blog')}>
            <span className="icon">
              <img alt={"sample.svg"} src={SsqImages.community.communityFooterBlog()} className="icon"/>
            </span>
            <span className="name">{props.getTranslation("I18N_TITLE_COMMUNITY_BLOG")}</span>
          </button>
        </li>
      ),
    },

    {
      tabTitle: (
        <li key={2}>
          <button className={clsx("c-footer info", activeIndex == 'board' ? 'on' : pathName == `/${country}/${lang}/community/board` ? "on" : '')}
            onClick={() => tabClickHandler('board')}>
            <span className="icon">
              <img alt={"sample.svg"} src={SsqImages.community.communityFooterInfo()} className="icon"/></span>
            <span className="name">{props.getTranslation("I18N_TITLE_COMMUNITY_BOARD")}</span>
          </button>
        </li>
      ),
    },

    {
      tabTitle: (
        <li key={3}>
          <button className={clsx("c-footer sample", activeIndex == 'sample' ? 'on' : pathName == `/${country}/${lang}/service/sample` ? "on" : '')}
            onClick={() => tabClickHandler('sample')}>
            <span className="icon">
              <img style={{paddingTop: ".3rem"}} alt={"sample.svg"} src={SsqImages.community.communitySample()} className="icon"/></span>
            <span className="name">{props.getTranslation("I18N_TITLE_COMMUNITY_SAMPLE")}</span>
          </button>
        </li>
      ),
    },

    {
      tabTitle: (

        <li key={4}>
          <button className={clsx("c-footer write",)}
            onClick={() => tabClickHandler('write')}>
            <span className="icon"></span>
            <span className="name">{props.getTranslation("I18N_TITLE_COMMUNITY_COMMON_HEADER_WRITE_BUTTON")}</span>
          </button>
        </li>
      ),
    },

  ];

  const [footerOn, setFooterOn] = useState(true);
  let lastScrollY = 0;
  useEffect(() => {

    function onScroll() {
      const scrollY = window.scrollY;
      const scrollEnd = document.body.scrollHeight - window.innerHeight;
      if (scrollY != scrollEnd) {
        const direction = scrollY > lastScrollY ? setFooterOn(false) : setFooterOn(true);
      } else {
        setFooterOn(true);
      }
      // 현재의 스크롤 값을 저장
      lastScrollY = scrollY;
      // console.log("scrollY", scrollY, "lastScrollY", lastScrollY, "footerOn", footerOn);
    }

    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, {passive: true});
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <MobileFooterContainer>
      <SubTabTableArea>
        <div
          className={clsx(props.languageService.getLanguage() === LANG_KO_KR ? "commonity-footer-menu" : "commonity-footer-menu commonity-footer-menu-en", footerOn ? "active" : "")}>
          <ul>
            {tabContArr.map((section) => {
              return section.tabTitle;
            })}
          </ul>
        </div>
      </SubTabTableArea>
    </MobileFooterContainer>
  );

};

//export default MobileFooter;

export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  }),

  dispatch => ({
    setLoginInfo: (info: IfLoginInfo) => dispatch({type: ACTION_TYPES.MAIN.LOGIN_INFO, payload: info}),
  })
)(MobileFooter));
